import classNames from "classnames";
import { FixLater } from "types";
import style from "./stages.module.scss";

export const PageStage = ({ appearance = "comfortable", className, children }: FixLater) => {
  return <section className={classNames(style.stageBase, style[appearance], className)}>{children}</section>;
};

export default PageStage;
